import React, { useContext } from "react";
import { AppContext } from "../States/AppContext";
import { Link } from "react-router-dom";

//styles
import {
  BedNumber,
  Flex,
  IconWrapper,
  PatientContainer,
  PatientName,
} from "./PatientDemo.elements";

//icons
import { BsPersonCircle } from "react-icons/bs";


const PatientDemo = () => {
  const { state, setState } = useContext(AppContext);

  return (
    <Link to="/settings/patient">
      <PatientContainer>
        {state.reboot ? (
          <BedNumber>Tele9</BedNumber>
        ) : (
          <>
            <BedNumber>T5U1Bed5</BedNumber>
            <Flex>
              <IconWrapper>
                <BsPersonCircle></BsPersonCircle>
              </IconWrapper>
              <PatientName> Patient, Demo</PatientName>
            </Flex>
          </>
        )}
      </PatientContainer>
    </Link>
  );
};

export default PatientDemo;
